import { Fragment } from 'react';
import styled, { css } from 'styled-components';

import { StatItem } from '@components/atoms';
import { device } from '@styles/mediaQuery';
import useDevice from '@hooks/useDevice';

function Statistics() {
  const { isTablet, isLaptop, isDesktop } = useDevice();

  return (
    <Wrapper>
      <StatItem title="135+" subtitle="trucks" />
      <Divider />

      <StatItem title="230+" subtitle="trailers" />
      <Divider />

      {(isLaptop || isDesktop) && (
        <Fragment>
          <StatItem title="6" subtitle="terminals" />
          <Divider />
        </Fragment>
      )}

      <StatItem title="30%" subtitle="team driver" />
      <Divider />

      {(isTablet || isLaptop || isDesktop) && (
        <StatItem title="24/7" subtitle="support" />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 1240px;

  margin: 0 auto;
  padding: 0 3px;
`;

const Divider = styled.div`
  display: none;

  position: relative;
  top: 16px;
  width: 1px;
  height: 59px;
  background-color: ${({ theme }) => theme.colors.divider};

  ${device.tablet(css`
    display: block;
  `)}
`;

export default Statistics;
